// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card[data-v-3d758473]{font-size:.8rem}.card-header[data-v-3d758473]{border:none !important}.container[data-v-3d758473]{border-top:1px solid var(--border-color)}`, "",{"version":3,"sources":["webpack://./client/components/Cards/CardAssignments.vue"],"names":[],"mappings":"AAGA,uBACE,eAAA,CAGF,8BACE,sBAAA,CAGF,4BACE,wCAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
